/* ============================================================
   PREMIUM LAYER — Behaviour
   Arabic Notebook · Designed by Thriftizer
   Vanilla, dependency-free, defensive. Every module no-ops when
   its markup is absent, so nothing here can break a Dawn page.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- tiny helpers ---------- */
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o); };
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function debounce(fn, wait) {
    var t; return function () {
      var a = arguments, c = this;
      clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait);
    };
  }
  function throttleRaf(fn) {
    var queued = false;
    return function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; fn(); });
    };
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m];
    });
  }
  function store(key, val) {
    try {
      if (val === undefined) { var r = localStorage.getItem(key); return r ? JSON.parse(r) : null; }
      localStorage.setItem(key, JSON.stringify(val));
      return val;
    } catch (e) { return null; }
  }
  function money(cents) {
    if (cents == null) return '';
    var fmt = window.PremiumTheme && window.PremiumTheme.moneyFormat;
    var val = (cents / 100).toFixed(2);
    if (fmt) return fmt.replace(/\{\{\s*amount\s*\}\}/, val).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    return val;
  }

  var PM = window.PremiumTheme = window.PremiumTheme || {};
  PM.$ = $; PM.$$ = $$; PM.money = money; PM.store = store;

  /* ============================================================
     1. SCROLL REVEAL
     ============================================================ */
  function initReveal(root) {
    var els = $$('.pm-reveal:not([data-pm-seen])', root || document);
    if (!els.length) return;
    if (REDUCED || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); el.setAttribute('data-pm-seen', ''); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { el.setAttribute('data-pm-seen', ''); io.observe(el); });
  }
  PM.initReveal = initReveal;

  /* Split headline into animatable words */
  function initWordAnim() {
    $$('.pm-anim-words:not([data-pm-split])').forEach(function (el) {
      el.setAttribute('data-pm-split', '');
      var words = el.textContent.trim().split(/\s+/);
      el.textContent = '';
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        s.textContent = w;
        s.style.transitionDelay = (i * 0.055) + 's';
        el.appendChild(s);
        if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
      });
    });
  }

  /* ============================================================
     2. HEADER — sticky, hide-on-scroll, height var
     ============================================================ */
  function initHeader() {
    var header = $('.pm-header');
    if (!header) return;

    function setH() {
      document.documentElement.style.setProperty('--pm-header-h', header.offsetHeight + 'px');
      var annc = document.querySelector('.pm-annc');
      document.documentElement.style.setProperty('--pm-annc-h', (annc ? annc.offsetHeight : 0) + 'px');
    }
    setH();
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(setH);
      ro.observe(header);
      var anncEl = document.querySelector('.pm-annc');
      if (anncEl) ro.observe(anncEl);
    }
    else on(window, 'resize', debounce(setH, 150));

    var last = window.pageYOffset;
    var hideOnScroll = header.dataset.hideOnScroll === 'true';
    var update = throttleRaf(function () {
      var y = window.pageYOffset;
      header.classList.toggle('is-stuck', y > 8);
      if (hideOnScroll && !document.body.classList.contains('pm-lock')) {
        var goingDown = y > last && y > 240;
        header.classList.toggle('is-hidden', goingDown);
      }
      last = y;
    });
    on(window, 'scroll', update, { passive: true });
    update();
  }

  /* ============================================================
     3. SCROLL LOCK + FOCUS TRAP
     ============================================================ */
  var lockCount = 0, scrollY = 0;
  function lockScroll(lock) {
    if (lock) {
      if (lockCount++ > 0) return;
      scrollY = window.pageYOffset;
      document.body.style.position = 'fixed';
      document.body.style.top = -scrollY + 'px';
      document.body.style.width = '100%';
      document.body.classList.add('pm-lock');
    } else {
      if (--lockCount > 0) return;
      lockCount = 0;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.classList.remove('pm-lock');
      window.scrollTo(0, scrollY);
    }
  }
  PM.lockScroll = lockScroll;

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function trapFocus(container) {
    if (!container) return function () {};
    function handler(e) {
      if (e.key !== 'Tab') return;
      var f = $$(FOCUSABLE, container).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    return function () { container.removeEventListener('keydown', handler); };
  }
  PM.trapFocus = trapFocus;

  /* ============================================================
     4. TOASTS
     ============================================================ */
  function toast(msg, opts) {
    opts = opts || {};
    var stack = $('.pm-toast-stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'pm-toast-stack';
      stack.setAttribute('role', 'status');
      stack.setAttribute('aria-live', 'polite');
      document.body.appendChild(stack);
    }
    var t = document.createElement('div');
    t.className = 'pm-toast';
    t.innerHTML = (opts.icon || '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>') +
                  '<span>' + esc(msg) + '</span>';
    stack.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () {
      t.classList.remove('is-in');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 400);
    }, opts.duration || 3200);
  }
  PM.toast = toast;

  /* ============================================================
     5. WISHLIST — localStorage backed, works with no app
     ============================================================ */
  var WL_KEY = 'pm_wishlist_v1';
  var Wishlist = {
    all: function () { return store(WL_KEY) || []; },
    has: function (id) { return this.all().some(function (i) { return String(i.id) === String(id); }); },
    add: function (item) {
      var list = this.all();
      if (this.has(item.id)) return list;
      list.unshift(item);
      store(WL_KEY, list);
      this.emit();
      return list;
    },
    remove: function (id) {
      var list = this.all().filter(function (i) { return String(i.id) !== String(id); });
      store(WL_KEY, list);
      this.emit();
      return list;
    },
    toggle: function (item) {
      var added = !this.has(item.id);
      added ? this.add(item) : this.remove(item.id);
      return added;
    },
    count: function () { return this.all().length; },
    emit: function () {
      document.dispatchEvent(new CustomEvent('pm:wishlist:change', { detail: { count: this.count(), items: this.all() } }));
    }
  };
  PM.Wishlist = Wishlist;

  function syncWishlistUI() {
    var n = Wishlist.count();
    $$('[data-pm-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    $$('.pm-wish[data-pm-wish-id]').forEach(function (btn) {
      var active = Wishlist.has(btn.dataset.pmWishId);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var lbl = active ? (btn.dataset.labelOn || 'Remove from wishlist') : (btn.dataset.labelOff || 'Add to wishlist');
      btn.setAttribute('aria-label', lbl);
      btn.setAttribute('title', lbl);
    });
  }

  function initWishlist() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.pm-wish[data-pm-wish-id]');
      if (!btn) return;
      e.preventDefault();
      var item = {
        id: btn.dataset.pmWishId,
        handle: btn.dataset.pmWishHandle || '',
        title: btn.dataset.pmWishTitle || '',
        image: btn.dataset.pmWishImage || '',
        price: btn.dataset.pmWishPrice || '',
        url: btn.dataset.pmWishUrl || '',
        variantId: btn.dataset.pmWishVariant || '',
        tag: btn.dataset.pmWishTag || '',
        meta: btn.dataset.pmWishMeta || ''
      };
      var added = Wishlist.toggle(item);
      toast(added ? (btn.dataset.msgOn || 'Saved to your wishlist') : (btn.dataset.msgOff || 'Removed from your wishlist'));
    });
    document.addEventListener('pm:wishlist:change', syncWishlistUI);
    syncWishlistUI();
  }

  /* ============================================================
     6. BACK TO TOP
     ============================================================ */
  function initBackToTop() {
    var btn = $('.pm-top');
    if (!btn) return;
    var update = throttleRaf(function () {
      btn.classList.toggle('is-in', window.pageYOffset > 600);
    });
    on(window, 'scroll', update, { passive: true });
    on(btn, 'click', function () {
      window.scrollTo({ top: 0, behavior: REDUCED ? 'auto' : 'smooth' });
    });
    update();
  }

  /* ============================================================
     7. MOBILE DRAWER
     ============================================================ */
  function initDrawer() {
    var drawer = $('.pm-mmenu') || $('.pm-drawer');
    var overlay = $('.pm-drawer__overlay');
    if (!drawer) return;
    var release = null, opener = null;

    function open() {
      opener = document.activeElement;
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      release = trapFocus(drawer);
      var f = $(FOCUSABLE, drawer); if (f) f.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      if (release) { release(); release = null; }
      if (opener && opener.focus) opener.focus();
    }
    PM.closeDrawer = close;

    $$('[data-pm-drawer-open]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); open(); }); });
    $$('[data-pm-drawer-close]').forEach(function (b) { on(b, 'click', close); });
    on(overlay, 'click', close);
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

    // nested submenu toggles
    $$('[data-pm-submenu-toggle]', drawer).forEach(function (btn) {
      on(btn, 'click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = expanded;
      });
    });
  }

  /* ============================================================
     8. GENERIC MODAL (size chart, etc.)
     ============================================================ */
  function initModals() {
    var release = null, opener = null;
    function openModal(m) {
      if (!m) return;
      opener = document.activeElement;
      m.classList.add('is-open');
      m.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      release = trapFocus(m);
      var f = $(FOCUSABLE, m); if (f) f.focus();
    }
    function closeModal(m) {
      if (!m) return;
      m.classList.remove('is-open');
      m.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      if (release) { release(); release = null; }
      if (opener && opener.focus) opener.focus();
    }
    PM.openModal = openModal; PM.closeModal = closeModal;

    document.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-pm-modal-open]');
      if (o) { e.preventDefault(); openModal(document.getElementById(o.dataset.pmModalOpen)); return; }
      var c = e.target.closest && e.target.closest('[data-pm-modal-close]');
      if (c) { e.preventDefault(); closeModal(c.closest('.pm-modal, .pm-lightbox')); return; }
      if (e.target.classList && e.target.classList.contains('pm-modal__scrim')) {
        closeModal(e.target.closest('.pm-modal'));
      }
    });
    on(document, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = $('.pm-modal.is-open') || $('.pm-lightbox.is-open');
      if (open) closeModal(open);
    });

    // unit toggle inside size charts
    $$('[data-pm-units]').forEach(function (group) {
      $$('button', group).forEach(function (btn) {
        on(btn, 'click', function () {
          var unit = btn.dataset.unit;
          $$('button', group).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          var scope = group.closest('.pm-modal__panel') || document;
          $$('[data-unit]', scope).forEach(function (el) {
            if (el.tagName === 'BUTTON') return;
            el.hidden = el.dataset.unit !== unit;
          });
        });
      });
    });
  }

  /* ============================================================
     9. ACCESSIBLE IMAGE LAZY-LOAD POLISH
     ============================================================ */
  function initImages() {
    $$('img[loading="lazy"]:not([data-pm-img])').forEach(function (img) {
      img.setAttribute('data-pm-img', '');
      if (img.complete) return;
      var wrap = img.closest('.pm-media, .pm-pcard__media');
      if (wrap) wrap.setAttribute('data-loading', 'true');
      img.addEventListener('load', function () { if (wrap) wrap.removeAttribute('data-loading'); }, { once: true });
      img.addEventListener('error', function () { if (wrap) wrap.removeAttribute('data-loading'); }, { once: true });
    });
  }


  /* ============================================================
     MOBILE ACCORDIONS — footer columns + SEO keyword clusters
     Panels ship open; they are only made collapsible once we know
     we are on a phone, so a no-JS render stays fully readable.
     ============================================================ */
  function initMobileAccordions() {
    var groups = $$('[data-pm-macc]');
    if (!groups.length) return;
    var mq = window.matchMedia('(max-width: 749px)');

    function apply() {
      var small = mq.matches;
      groups.forEach(function (g) {
        var head = g.querySelector('[data-pm-macc-head]');
        var panel = g.querySelector('[data-pm-macc-panel]');
        if (!head || !panel) return;
        if (small) {
          g.classList.add('is-collapsible');
          if (!g.classList.contains('is-open')) head.setAttribute('aria-expanded', 'false');
        } else {
          g.classList.remove('is-collapsible', 'is-open');
          head.setAttribute('aria-expanded', 'true');
        }
      });
    }

    groups.forEach(function (g) {
      var head = g.querySelector('[data-pm-macc-head]');
      if (!head) return;
      on(head, 'click', function () {
        if (!g.classList.contains('is-collapsible')) return;
        var open = g.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  /* ---------- boot ---------- */
  function boot() {
    initReveal();
    initWordAnim();
    initHeader();
    initDrawer();
    initModals();
    initWishlist();
    initBackToTop();
    initImages();
    initMobileAccordions();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-init after Shopify section renders (theme editor + AJAX)
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target); initWordAnim(); initImages(); syncWishlistUI();
  });
  document.addEventListener('pm:rendered', function (e) {
    initReveal(e.detail && e.detail.root); initImages(); syncWishlistUI();
  });
})();

/* ============================================================
   VIDEO ROW — landscape carousel with scrub bar
   Loaded globally so the section works on any template.
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fmt(t) {
    if (!isFinite(t)) return '0:00';
    var m = Math.floor(t / 60), s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function initRow(section) {
    if (!section || section.dataset.pmVidReady) return;
    section.dataset.pmVidReady = '1';

    var track = $('[data-pm-vid-track]', section);
    var cards = $$('[data-pm-vidcard]', section);
    if (!track || !cards.length) return;
    var muted = true;

    function hydrate(card) {
      var v = $('video', card);
      if (!v || v.dataset.pmHydrated) return v;
      v.dataset.pmHydrated = '1';
      var sources = $$('source[data-src]', v);
      if (sources.length) sources.forEach(function (s) { s.src = s.dataset.src; });
      else if (v.dataset.src) v.src = v.dataset.src;
      v.load();
      return v;
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) hydrate(e.target); });
      }, { rootMargin: '400px' });
      cards.forEach(function (c) { io.observe(c); });
    }

    cards.forEach(function (card) {
      var play = $('.pm-vidcard__play', card);
      var mute = $('.pm-vidcard__mute', card);
      var timeEl = $('[data-pm-vid-time]', card);
      var bar = $('[data-pm-vid-progress]', card);

      function start() {
        var v = hydrate(card);
        if (!v) return;
        cards.forEach(function (o) {
          if (o === card) return;
          var ov = $('video', o);
          if (ov && !ov.paused) { ov.pause(); o.classList.remove('is-playing'); }
        });
        v.muted = muted;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        card.classList.add('is-playing');
      }
      function stop() {
        var v = $('video', card);
        if (v && !v.paused) v.pause();
        card.classList.remove('is-playing');
      }

      if (play) play.addEventListener('click', function (e) { e.stopPropagation(); start(); });
      card.addEventListener('click', function (e) {
        if (e.target.closest('button')) return;
        var v = $('video', card);
        if (!v) return;
        v.paused ? start() : stop();
      });

      if (mute) {
        mute.addEventListener('click', function (e) {
          e.stopPropagation();
          muted = !muted;
          $$('video', section).forEach(function (v) { v.muted = muted; });
          $$('.pm-vidcard__mute', section).forEach(function (b) {
            b.setAttribute('aria-pressed', muted ? 'false' : 'true');
            b.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
          });
        });
      }

      var v0 = $('video', card);
      if (v0 && (timeEl || bar)) {
        v0.addEventListener('timeupdate', function () {
          if (timeEl) timeEl.textContent = fmt(v0.currentTime) + ' / ' + fmt(v0.duration);
          if (bar && v0.duration) bar.style.width = ((v0.currentTime / v0.duration) * 100) + '%';
        });
        v0.addEventListener('loadedmetadata', function () {
          if (timeEl) timeEl.textContent = '0:00 / ' + fmt(v0.duration);
        });
      }
    });

    function scrollByCard(dir) {
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '16');
      track.scrollBy({ left: dir * (cards[0].offsetWidth + gap), behavior: REDUCED ? 'auto' : 'smooth' });
    }
    $$('[data-pm-vid-prev]', section).forEach(function (b) { b.addEventListener('click', function () { scrollByCard(-1); }); });
    $$('[data-pm-vid-next]', section).forEach(function (b) { b.addEventListener('click', function () { scrollByCard(1); }); });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) cards.forEach(function (c) {
        var v = $('video', c);
        if (v && !v.paused) { v.pause(); c.classList.remove('is-playing'); }
      });
    });
  }

  function boot() { $$('[data-pm-vidrow]').forEach(initRow); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
